<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Attributs</h1>
                    <p>Gestion des attributs</p>
                </div>

                <div class="actions">
                    <ul>
                        <li><button @click="importFile()"><span>Importer</span></button></li>
                        <li><button class="bt-primary" @click="create()"><i class="icon icon-icon_person-add"></i><span>Créer</span></button></li>
                    </ul>
                </div>

            </div>
        </header>
        <div class="content-body">

            <section>
                <div class="search">
                    <!--
                    <nav>
                        <ul>
                            <li v-bind:class="paginator.filter == '' ? 'is-active' : ''">
                                <a @click="setFilter('')"><span>Tout</span></a></li>
                            <li v-bind:class="paginator.filter == 'pending' ? 'is-active' : ''">
                                <a @click="setFilter('pending')"><span>En attente</span></a></li>
                            <li v-bind:class="paginator.filter == 'in_progress' ? 'is-active' : ''">
                                <a @click="setFilter('in_progress')"><span>En cours</span></a></li>
                            <li v-bind:class="paginator.filter == 'completed' ? 'is-active' : ''">
                                <a @click="setFilter('completed')"><span>Terminé</span></a></li>
                        </ul>
                    </nav>
                    -->
                    <div>
                        <input type="text" placeholder="Recherche" v-model="query"/>
                        <button><i class="icon icon-icon_search"></i></button>
                    </div>
                </div>

                <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

                <div class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div v-bind:class="[ paginator.sort == 'name' ? 'active' : '', paginator.order ]">
                                <span data-sort="name" @click="setOrder($event)">Nom</span>
                            </div>
                            <div v-bind:class="[ paginator.sort == 'slug' ? 'active' : '', paginator.order ]">
                                <span data-sort="slug" @click="setOrder($event)">slug</span>
                            </div>
                            <div v-bind:class="[ paginator.sort == 'type' ? 'active' : '', paginator.order ]">
                                <span data-sort="type" @click="setOrder($event)">type</span>
                            </div>
                            <div><span>Parent</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)">
                            <div></div>
                            <div class="picture no-radius">
                                <figure>
                                    <i class="icon icon-icon_tags"></i>
                                </figure>
                            </div>
                            <div data-field="name"><strong>{{ item.name }}</strong></div>
                            <div data-field="slug" style="white-space: nowrap;">{{ item.slug }}</div>
                            <div data-field="type" style="white-space: nowrap;">{{ item.type }}</div>
                            <div data-field="parent" style="white-space: nowrap;">{{ item.parent ? item.parent.slug : '' }}</div>
                            <div class="actions">
                                <ul>
                                    <li><button @click="remove(item.id)"><i class="icon icon-icon_delete"></i></button></li>
                                    <li><button @click="edit(item.id)"><i class="icon icon-icon_pencil"></i></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import AttributeService from './AttributeService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return {name: 'attribute', api: AttributeService};
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/attribute/Index.vue